/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
/*
* Custom JS for Broadcast Theme — Force Mobile Slider Dots
*/
(function() {
  function initMobileDots() {
    var section = document.getElementById("SectionColumns--template--24286186504439__section_text_row_bAWdGE");
    if (!section) return;

    var slider = section.querySelector(".grid--mobile-slider");
    if (!slider) return;

    // Only run on mobile
    if (window.innerWidth > 749) return;

    // Remove existing dots container if any
    var existingDots = section.querySelector(".mobile-slider-dots");
    if (existingDots) existingDots.remove();

    // Create dots container
    var dotsContainer = document.createElement("div");
    dotsContainer.className = "mobile-slider-dots";
    section.appendChild(dotsContainer);

    var items = slider.querySelectorAll(".grid-item");
    var dots = [];

    // Create a dot for each item
    items.forEach(function(_, index) {
      var dot = document.createElement("div");
      dot.className = "dot";
      dot.addEventListener("click", function() {
  // Scroll horizontally only
  var sliderRect = slider.getBoundingClientRect();
  var itemRect = items[index].getBoundingClientRect();
  var scrollLeft = slider.scrollLeft + (itemRect.left - sliderRect.left) - (sliderRect.width/2 - itemRect.width/2);
  
  slider.scrollTo({ left: scrollLeft, behavior: "smooth" });
});

      dotsContainer.appendChild(dot);
      dots.push(dot);
    });

    // Update active dot on scroll
    function updateActiveDot() {
      var sliderRect = slider.getBoundingClientRect();
      var center = sliderRect.left + sliderRect.width / 2;

      items.forEach(function(item, index) {
        var itemRect = item.getBoundingClientRect();
        if (itemRect.left <= center && itemRect.right >= center) {
          dots.forEach(d => d.classList.remove("active"));
          dots[index].classList.add("active");
        }
      });
    }

    slider.addEventListener("scroll", updateActiveDot);
    updateActiveDot();
  }

  window.addEventListener("load", initMobileDots);
  window.addEventListener("resize", initMobileDots);
  document.addEventListener("shopify:section:load", initMobileDots);
})();




  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
